import request from '@/utils/request'
// 光流图加载
export default function setOption(config) {
  let chart = this.chart
  // 读取光流数据配置
  let series = []
  for (let file in config) {
    const cfg = config[file]
    let lineColor = cfg.color // 光流颜色
    let lineSpoit = cfg.spoit // 亮度
    let lineWidth = cfg.width // 光流线宽
    let url = config.url || './map/json/line/' + file + '.json'
    //获取光流数据
    request.get(url).then(res => {
      let lines = []
      for (let item of res.features) {
        let line = []
        // geojson格式
        if (item.geometry.coordinates) {
          line = item.geometry.coordinates
        } else if (item.geometry.paths) {
          // arcGis 格式
          line = item.geometry.paths[0]
        }
        lines.push({
          coords: line
        })
      }
      let serie = {
        type: 'lines3D',
        coordinateSystem: 'mapbox',
        effect: {
          show: true,
          opacity: 0.6,
          period: 5,
          constantSpeed: 10, //光点前进速度
          trailWidth: 2, //前进过程中的线宽
          trailColor: lineColor,
          trailLength: 2, //光点大小
          spotIntensity: lineSpoit //光点亮度
        },
        blendMode: 'lighter', //blendMode设置为lighter时当多条线路叠加可以高亮
        polyline: true, //在 polyline 设置为 true 时支持多于两个的坐标
        lineStyle: {
          opacity: 0.6, //路线不透明度
          width: lineWidth, //底层路线的宽度
          color: lineColor,
          shadowBlur: 0.1 //阴影模糊效果控制不明显
        },
        data: lines
      }
      series.push(serie)
      chart.setOption({ series })
    })
  }

  return series
}



// WEBPACK FOOTER //
// ./src/framework/map/layer/Lines-3D.js